import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * SCRUM-147: requests that already show their own, page-specific loading
 * state (e.g. "טוען פרטי מודעה..." in the ad-details dialog) opt out of the
 * global full-page spinner, so the user doesn't see two spinners at once.
 */
export const SKIP_GLOBAL_SPINNER = new HttpContextToken<boolean>(() => false);

export function withoutGlobalSpinner(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_GLOBAL_SPINNER, true);
}
